import React, { useEffect, useState } from 'react';
import { useCompanyId } from '../../services/CompanyidProvider';
import EntitlementsTab from '../../components/Entitlements/EntitlementsTab';
import { Box, CircularProgress } from '@mui/material';

function EntitlementsPage() {
  const { companyId: contextCompanyId, setCompanyId } = useCompanyId();
  const [loading, setLoading] = useState(true);
  const [finalCompanyId, setFinalCompanyId] = useState(null);

  useEffect(() => {
    // Get company ID from localStorage (set by CompanyManagement page)
    const storedCompanyId = localStorage.getItem('selectedCompanyId');
    
    if (storedCompanyId && setCompanyId) {
      setCompanyId(storedCompanyId);
      setFinalCompanyId(storedCompanyId);
      // Clear it after use
      localStorage.removeItem('selectedCompanyId');
      localStorage.removeItem('selectedCompanyName');
    } else if (contextCompanyId) {
      setFinalCompanyId(contextCompanyId);
    }
    
    setLoading(false);
  }, [contextCompanyId, setCompanyId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress sx={{ color: '#188C8E' }} />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <EntitlementsTab companyId={finalCompanyId || contextCompanyId} />
    </Box>
  );
}

export default EntitlementsPage;